import Component from '@glimmer/component';
import DetailWithIcon from './progress-tracker/detail-with-icon.gts';
import NoDetails from './progress-tracker/no-details.gts';
import FullHistory from './progress-tracker/full-history.gts';
import { ApproverDetail } from './progress-tracker/approver-detail.gts';
import type TasApplicationModel from 'tio-data/models/tas-application';

export type Step = {
  title?: string;
  completed?: boolean;
  inProgress?: boolean;
  details?: Detail[];
  actionNeeded?: boolean;
  iconBackground?: string;
};

export interface Detail {
  componentName?: string;
  props?: Record<string, unknown>;
}

export interface ProgressTrackerItemsArgs {
  Args: {
    componentName?: string;
    props?: Props;
  };
}

interface Props {
  icon?: string;
  detail?: string;
  iconBgColor?: string;
  application?: TasApplicationModel;
  stepToApprove?: number;
}

export default class ProgressTrackerItems extends Component<ProgressTrackerItemsArgs> {
  get selectedComponent() {
    const { componentName } = this.args;
    switch (componentName) {
      case 'DetailWithIcon':
        return DetailWithIcon;
      case 'ApproverDetail':
        return ApproverDetail;
      case 'FullHistory':
        return FullHistory;
      default:
        return NoDetails;
    }
  }
  <template>
    <this.selectedComponent
      @icon={{@props.icon}}
      @detail={{@props.detail}}
      @iconBgColor={{@props.iconBgColor}}
      @application={{@props.application}}
      @stepToApprove={{@props.stepToApprove}}
    />
  </template>
}
